import React, { useState, useEffect } from 'react';
import { getDashboard } from '../../api/admin';
import AdminLayout from './AdminLayout';
import './AdminDashboard.css';

const STATUS_COLORS = {
  new: '#423A8E',
  contacted: '#00CCCD',
  'quotation sent': '#FFC107',
  'in progress': '#0D6EFD',
  completed: '#198754',
  closed: '#DC3545',
};

// SVG Icons
const Icons = {
  Inbox: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  ),
  Bell: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  ),
  Leaf: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c3.314 0 6-2.686 6-6 0-3.314-2.686-6-6-6C8.686 10 6 12.686 6 16c0 3.314 2.686 6 6 6z" />
      <path d="M12 10V4" />
      <path d="M8 8l4-4 4 4" />
    </svg>
  ),
  Building: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
      <line x1="9" y1="22" x2="9" y2="18" />
      <line x1="15" y1="22" x2="15" y2="18" />
      <line x1="9" y1="14" x2="9" y2="10" />
      <line x1="15" y1="14" x2="15" y2="10" />
    </svg>
  ),
  Box: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  Image: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  Users: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Star: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Plus: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Upload: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Sliders: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="2" y1="14" x2="6" y2="14" />
      <line x1="10" y1="12" x2="14" y2="12" />
      <line x1="18" y1="16" x2="22" y2="16" />
    </svg>
  ),
};

function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDashboard()
      .then((res) => { if (res.success) setData(res.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <AdminLayout title="Dashboard">
      <div className="adm-loading">Loading dashboard...</div>
    </AdminLayout>
  );

  const counts = data?.counts || {};
  const recent = data?.recent_inquires || [];

  const STAT_CARDS = [
    { label: 'Total Inquiries', value: counts.total_inquiries, icon: Icons.Inbox, color: '#423A8E', link: '/admin/inquiries' },
    { label: 'New Inquiries', value: counts.new_inquiries, icon: Icons.Bell, color: '#00CCCD', link: '/admin/inquiries' },
    { label: 'Services', value: counts.total_services, icon: Icons.Leaf, color: '#423A8E', link: '/admin/services' },
    { label: 'Projects', value: counts.total_projects, icon: Icons.Building, color: '#00CCCD', link: '/admin/projects' },
    { label: 'Products', value: counts.total_products, icon: Icons.Box, color: '#423A8E', link: '/admin/products' },
    { label: 'Gallery Items', value: counts.total_gallery, icon: Icons.Image, color: '#00CCCD', link: '/admin/gallery' },
    { label: 'Clients', value: counts.total_clients, icon: Icons.Users, color: '#423A8E', link: '#' },
    { label: 'Testimonials', value: counts.total_testimonials, icon: Icons.Star, color: '#00CCCD', link: '/admin/testimonials' },
  ];

  const QUICK_ACTIONS = [
    { label: 'Add Service', icon: Icons.Plus, link: '/admin/services' },
    { label: 'Add Project', icon: Icons.Plus, link: '/admin/projects' },
    { label: 'Add Product', icon: Icons.Plus, link: '/admin/products' },
    { label: 'Upload Gallery', icon: Icons.Upload, link: '/admin/gallery' },
    { label: 'Manage Sliders', icon: Icons.Sliders, link: '/admin/sliders' },
    { label: 'Add Testimonial', icon: Icons.Star, link: '/admin/testimonials' },
  ];

  return (
    <AdminLayout title="Dashboard">

      {/* Stat Cards */}
      <div className="adm-stat-grid">
        {STAT_CARDS.map((card) => {
          const IconComponent = card.icon;
          return (
            <a key={card.label} href={card.link} className="adm-stat-card">
              <div className="adm-stat-card__icon" style={{ background: card.color + '15', color: card.color }}>
                <IconComponent />
              </div>
              <div className="adm-stat-card__info">
                <span className="adm-stat-card__value">{card.value ?? 0}</span>
                <span className="adm-stat-card__label">{card.label}</span>
              </div>
            </a>
          );
        })}
      </div>

      {/* Recent Inquiries */}
      <div className="adm-card">
        <div className="adm-card__header">
          <h3>Recent Inquiries</h3>
          <a href="/admin/inquiries" className="adm-card__link">View All →</a>
        </div>
        <div className="adm-card__body">
          {recent.length === 0 ? (
            <div className="adm-empty">
              <p>No inquiries yet.</p>
            </div>
          ) : (
            <div className="adm-table-wrap">
              <table className="adm-table">
                <thead>
                  <tr>
                    <th>Inquiry No</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {recent.map((inq) => (
                    <tr key={inq.id}>
                      <td><code>{inq.inquiry_no}</code></td>
                      <td>{inq.name}</td>
                      <td>{inq.phone}</td>
                      <td className="adm-capitalize">{inq.inquiry_type}</td>
                      <td>
                        <span
                          className="adm-badge"
                          style={{ 
                            background: (STATUS_COLORS[inq.status] || '#6b7280') + '20', 
                            color: STATUS_COLORS[inq.status] || '#6b7280' 
                          }}
                        >
                          {inq.status}
                        </span>
                      </td>
                      <td>{new Date(inq.created_at).toLocaleDateString('en-IN')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="adm-card">
        <div className="adm-card__header">
          <h3>Quick Actions</h3>
        </div>
        <div className="adm-card__body">
          <div className="adm-quick-grid">
            {QUICK_ACTIONS.map((action) => {
              const IconComponent = action.icon;
              return (
                <a key={action.label} href={action.link} className="adm-quick-card">
                  <span className="adm-quick-card__icon" style={{ color: '#423A8E' }}>
                    <IconComponent />
                  </span>
                  {action.label}
                </a>
              );
            })}
          </div>
        </div>
      </div>

    </AdminLayout>
  );
}

export default AdminDashboard;